<template>
    <div class="jiuzhang">
        <div class="first">
            <div class="content">
                <div class="text">
                    <p>
                        <span>九章</span><span>研究院</span>
                    </p>
                    <p>
                       近年来，人工智能、量化策略等技术在投资领域已经发展得如火如荼，但在金融同业固收投资方面的应用还相对初级。九章研究院的研究团队依据每个客户的不同需求，提供精细化和专业化的深度定制解决方案，致力于将最好、最先进的技术应用到固收领域投资策略的研发中，为新时代各大金融机构军备竞赛提供强有力支撑。
                    </p>
                </div>

            </div>
        </div>

        <div class="two">
            <div class="content">
                <div class="two-title">
                    <p>投研策略服务体系</p>
                </div>
                <div class="two-content-two">
                    <div class="content-icon">
                        <img src="../assets/jiuzhang-back-one.jpg"
        srcset="../assets/jiuzhang-back-one@2x.jpg 2x,
                ../assets/jiuzhang-back-one@3x.jpg 3x" class="special1">
                        <p>
                            全品类基金智能优选FOF策略
                        </p>
                        <p>
                            全品类基金智能优选策略投顾服务是基于大数据与人工智能技术，用于筛选优质基金产品的一套解决方案。总体框架分为数据采集、数据处理、模型训练、结果应用四个部分。
                        </p>
                    </div>
                    <div class="content-icon">
                        <img src="../assets/jiuzhang-back-two.jpg"
        srcset="../assets/jiuzhang-back-two@2x.jpg 2x,
                ../assets/jiuzhang-back-two@3x.jpg 3x" class="special2">
                        <p>
                            大类资产配置
                        </p>
                        <p>
                           采用最大化夏普率的思路，利用自主研发的智能风控信号，在组合中加入了大宗商品和国债来对冲风险，使得整个资产组合在实现夏普收益率最大化的同时，控制策略的回撤和波动。 
                        </p>
                    </div>
                    <div class="content-icon">
                        <img src="../assets/jiuzhang-back-three.jpg"
        srcset="../assets/jiuzhang-back-three@2x.jpg 2x,
                ../assets/jiuzhang-back-three@3x.jpg 3x">
                        <p>
                            程序化交易策略
                        </p>
                        <p>
                            95%的工作通过人工智能技术自动完成，交易客观稳定，利用数百台机器的上万计算单元，提升策略研发效率和策略稳定性。
                        </p>
                    </div>
                
                </div>
                
            </div>
        </div>
        <div class="three">
            <img src="../assets/jiuzhang-back-third.png"
     srcset="../assets/jiuzhang-back-third@2x.png 2x">
        </div>
        <div class="four">
            <div class="content">
                <div class="text">
                    <p>
                       资讯服务平台 
                    </p>
                    <p>
                       资讯服务平台提供股市、外汇、期货、基金以及债券的实时新闻、动态图表、技术分析、财经日历及其他多种工具和计算器，是金融市场工具和资讯的权威来源。
                    </p>
                    <p>
                        凭借广大的用户群体及业界领先的技术团队，我们将为同业提供精准的金融资讯，共建有价值的互联网金融资讯圈。
                    </p>
                    
                </div>
                <img src="../assets/jiuzhang-back-phone.png"
     srcset="../assets/jiuzhang-back-phone@2x.png 2x,
             ../assets/jiuzhang-back-phone@3x.png 3x" class="imgOne">

            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    name: 'jiuzhang'
}
</script>

<style lang="scss">
.jiuzhang{
    min-width: 1000px;
    .first{
        min-height: 390px;
        background: url("../assets/jiuzhang-back-first.jpg") no-repeat center/cover;
        @media only screen and (min--moz-device-pixel-ratio: 2),

        only screen and (-o-min-device-pixel-ratio: 2/1),

        only screen and (-webkit-min-device-pixel-ratio: 2),

        only screen and (min-device-pixel-ratio: 2){
            background: url("../assets/jiuzhang-back-first@2x.jpg") no-repeat center/cover;
        }
        @media only screen and (min--moz-device-pixel-ratio: 3),

        only screen and (-o-min-device-pixel-ratio: 3/1),

        only screen and (-webkit-min-device-pixel-ratio: 3),

        only screen and (min-device-pixel-ratio: 3){
            background: url("../assets/jiuzhang-back-first@3x.jpg") no-repeat center/cover;
        }

        .content{
            width: 1000px;
            margin: 0 auto;
            color: #fff;
            padding:1px;
            .text{
                width: 637px;
                margin: 0 auto;
                margin-top: 135px;
                text-align: center;
                p:nth-child(1){
                    font-size: 40px;
                    font-weight: bold;
                    line-height: 1.5;
                    margin-bottom: 24px;
                    span:nth-child(1){
                        color:#fcc617
                    }
                }
                p:nth-child(2){
                    font-size: 14px;
                    line-height: 1.86;
                }
            }
        }
    }
   .two{
        width: 100%;
        overflow: hidden;
        .content{
           width: 1000px;
           margin: 75px auto;
           .two-title{
               width: 630px;
               height: 85px;
               margin: 0 auto;
               text-align: center;
               margin-bottom: 42px;
               p:nth-child(1){
                   font-size: 30px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.33;
                    letter-spacing: normal;
                    text-align: center;
                    color: #000;
               }
           }
           .two-content-two{
               margin: 0 auto;
               display: flex;
               .content-icon{
                   padding: 0 25px;
                   text-align: center;
                   width: 280px;
                   .special1{
                       padding-top: 15px;
                       padding-bottom:26px;
                   }
                   .special2{
                       padding-top: 15px;
                       padding-bottom:35px;
                   }
                   p:nth-child(2){
                       margin-top: 26px;
                        color: #064ec1;
                        font-size: 20px;
                        line-height: 2;
                        font-weight: bold;
                    }
                    p:nth-child(3){
                        color: #000;
                        font-size: 14px;
                        line-height: 1.86;
                    }
               }
           } 
        }
    }

    .three{
        img{
            
            width: 100%;
        }
    }
    .four{
        min-height: 500px;
        background: url("../assets/jiuzhang-back-four.jpg") no-repeat center/cover;
        @media only screen and (min--moz-device-pixel-ratio: 2),

        only screen and (-o-min-device-pixel-ratio: 2/1),

        only screen and (-webkit-min-device-pixel-ratio: 2),

        only screen and (min-device-pixel-ratio: 2){
            background: url("../assets/jiuzhang-back-four@2x.jpg") no-repeat center/cover;
        }
        @media only screen and (min--moz-device-pixel-ratio: 3),

        only screen and (-o-min-device-pixel-ratio: 3/1),

        only screen and (-webkit-min-device-pixel-ratio: 3),

        only screen and (min-device-pixel-ratio: 3){
            background: url("../assets/jiuzhang-back-four@3x.jpg") no-repeat center/cover;
        }
        .content{
            width: 1000px;
            margin: 0 auto;
            color: #fff;
            padding:1px;
            position: relative;
            .text{
                width: 413px;
                margin-top: 110px;
                margin-left: 500px;
                p{
                    margin-bottom:24px;
                }
                p:nth-child(1){
                    font-size: 30px;
                    font-weight: bold;
                    line-height: 1.33;
                }
                p:nth-child(2),p:nth-child(3){
                    width:418px;
                    font-size: 14px;
                    line-height: 1.86;
                }
            }
            img.imgOne{
                position: absolute;
                left: 45px;
                top: 37px;
            }
        }
    }
}
</style>